(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zoura-anniversary-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zoura-anniversary-faq')) {
  customElements.define('zoura-anniversary-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.faqController) return;
      this.faqController = new AbortController();
      const signal = this.faqController.signal;
      this.addEventListener('toggle', (event) => {
        const current = event.target;
        if (!current.matches('.zaf__item') || !current.open) return;
        this.querySelectorAll('.zaf__item[open]').forEach((item) => {
          if (item !== current) item.open = false;
        });
      }, { capture: true, signal });
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail && event.detail.blockId;
          const current = Array.from(this.querySelectorAll('.zaf__item')).find((item) => item.dataset.blockId === blockId);
          if (!current) return;
          this.querySelectorAll('.zaf__item').forEach((item) => { item.open = item === current; });
        }, { signal });
      }
    }
    disconnectedCallback() {
      if (this.faqController) this.faqController.abort();
      this.faqController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoura-anniversary-thank-you"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zoura-anniversary-thanks')) {
  customElements.define('zoura-anniversary-thanks', class extends HTMLElement {
    connectedCallback() {
      if (this.thanksController) return;
      this.thanksController = new AbortController();
      const signal = this.thanksController.signal;
      this.thanksInView = false;
      this.thanksMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => this.classList.toggle('zat--visible', this.thanksInView && !document.hidden && !this.thanksMedia.matches && !(navigator.connection && navigator.connection.saveData));
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-zat-top]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        window.scrollTo({ top: 0, left: 0, behavior: this.thanksMedia.matches ? 'instant' : 'smooth' });
        const target = document.querySelector('header a[href], header button, h1');
        if (target) {
          const hadTabindex = target.hasAttribute('tabindex');
          if (!hadTabindex) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          if (!hadTabindex) target.removeAttribute('tabindex');
        }
      }, { signal });
      document.addEventListener('visibilitychange', update, { signal });
      this.thanksMedia.addEventListener('change', update, { signal });
      if ('IntersectionObserver' in window) {
        this.thanksObserver = new IntersectionObserver((entries) => {
          this.thanksInView = entries.some((entry) => entry.isIntersecting);
          update();
        }, { threshold: 0 });
        this.thanksObserver.observe(this);
      } else {
        this.thanksInView = true;
        update();
      }
    }
    disconnectedCallback() {
      if (this.thanksObserver) this.thanksObserver.disconnect();
      if (this.thanksController) this.thanksController.abort();
      this.classList.remove('zat--visible');
      this.thanksController = null;
      this.thanksObserver = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
